/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Icon_Info1Inputs */

const vi_sitesettings_icon_info1 = /** @type {(inputs: Sitesettings_Icon_Info1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin`)
};

/**

* @param {Sitesettings_Icon_Info1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_icon_info1 = /** @type {((inputs?: Sitesettings_Icon_Info1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Icon_Info1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_icon_info1(inputs)
});
export { sitesettings_icon_info1 as "siteSettings_icon_info" }